import {apiClient} from "@/plugins/axios";

export default {
    create() {},
    read() {
        return apiClient.get("/sites");
    },
    update() {},
    destroy() {},
}